import { FadeUp } from "./anim";
import { IMAGES } from "./site-data";

export const Gallery = () => {
  return (
    <section
      id="gallery"
      className="relative bg-sg-bg py-24 sm:py-32"
      data-testid="gallery-section"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <FadeUp className="max-w-2xl mb-16">
          <span className="text-xs uppercase tracking-[0.25em] text-sg-primary">
            In real spaces
          </span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-sg-fg">
            Made for every backyard.
          </h2>
          <p className="mt-5 text-base text-sg-muted font-light max-w-md">
            From compact condo balconies to ocean-view decks — it fits, and it
            elevates.
          </p>
        </FadeUp>

        <div className="grid gap-4 sm:gap-6 md:grid-cols-12">
          <FadeUp className="md:col-span-7" y={60}>
            <figure className="relative overflow-hidden rounded-2xl border border-white/5 aspect-[16/11] group">
              <img
                src={IMAGES.daytimeTerrace}
                alt="Solar Garden on a hillside terrace"
                className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105"
              />
              <figcaption className="absolute bottom-5 left-5 rounded-full bg-sg-bg/70 backdrop-blur px-4 py-1.5 text-xs tracking-wide text-sg-fg">
                Hillside terrace
              </figcaption>
            </figure>
          </FadeUp>

          <FadeUp className="md:col-span-5" y={80} delay={0.1}>
            <figure className="relative overflow-hidden rounded-2xl border border-white/5 aspect-[16/11] md:h-full group">
              <img
                src={IMAGES.sunsetLiving}
                alt="Solar Garden beside a sunset ocean-view living space"
                className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105"
              />
              <figcaption className="absolute bottom-5 left-5 rounded-full bg-sg-bg/70 backdrop-blur px-4 py-1.5 text-xs tracking-wide text-sg-fg">
                Sunset living space
              </figcaption>
            </figure>
          </FadeUp>

          <FadeUp className="md:col-span-5" y={80} delay={0.05}>
            <figure className="relative overflow-hidden rounded-2xl border border-white/5 aspect-[16/11] md:h-full group">
              <img
                src={IMAGES.collage}
                alt="Solar Garden from showroom to home"
                className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105"
              />
              <figcaption className="absolute bottom-5 left-5 rounded-full bg-sg-bg/70 backdrop-blur px-4 py-1.5 text-xs tracking-wide text-sg-fg">
                Showroom to home
              </figcaption>
            </figure>
          </FadeUp>

          <FadeUp className="md:col-span-7" y={60} delay={0.1}>
            <figure className="relative overflow-hidden rounded-2xl border border-white/5 aspect-[16/11] group">
              <img
                src={IMAGES.product3}
                alt="Solar Garden detail views"
                className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105"
              />
              <figcaption className="absolute bottom-5 left-5 rounded-full bg-sg-bg/70 backdrop-blur px-4 py-1.5 text-xs tracking-wide text-sg-fg">
                Courtyard &amp; garden
              </figcaption>
            </figure>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
